

import React from 'react';
import { Star } from 'react-feather';
import { useTranslation } from 'react-i18next';

interface KeyFactsBoxProps {
  facts: string[];
}

const KeyFactsBox: React.FC<KeyFactsBoxProps> = ({ facts }) => {
  const { t } = useTranslation('common');
  if (!facts || facts.length === 0) return null;

  return (
    <div className="p-6 rounded-2xl border border-white/10 bg-white/5 glass-effect">
      <h3 className="text-xl font-bold font-serif mb-4">{t('blogPostPage.keyFacts')}</h3>
      <ul className="space-y-3">
        {facts.map((fact, index) => (
          <li key={index} className="flex items-start gap-3">
            <Star className="h-5 w-5 text-brand-gold-light flex-shrink-0 mt-1" />
            <span className="text-white/90">{fact}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KeyFactsBox;